<template>
  <div class="pre-seat-map">
    <div class="seat-row seat-row-head">
      <div class="seat-title" v-for="(col, index) in seatData[0]" :key="index">
        <div v-if="col.col!='=' && col.seatStatus!='E'">{{col.col}}</div>
        <div v-else-if="col.col=='='" class="space"></div>
      </div>
    </div>
    <div class="seat-row" v-for="(row, rowIndex) in seatData" :key="rowIndex">
      <seat-col :seatRow="row" @selectSeat="onSelectSeat"></seat-col>
    </div>
  </div>
</template>

<script>
import seatCol from './seat-col'
export default {
  props: {
    seatData: Array
  },
  methods: {
    onSelectSeat (seatItem, method) {
      this.$emit('selectSeat', seatItem, method)
    }
  },
  components: {
    seatCol
  }
}
</script>
<style lang="less">
.pre-seat-map {
    position: relative;
    min-width: 500px;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
  .seat-row {
    width: 20px;
    height: 100%;
    margin: 0 3px;
    display: inline-block;
    white-space: nowrap;
    vertical-align: top;
    .seat-title {
      div {
        display: block;
        width: 19px;
        height: 19px;
        line-height: 19px;
        margin: 3px 0;
        font-size: 12px;
        text-align: center;
      }
    }
  }
  .seat-row-head {
    .seat {
      background: none;
    }
  }
  .seat-row-head, .seat-row-item {
    display: flex;
    flex-direction: column-reverse;
  }
}
@media only screen and (max-width: 768px) {
  .airplane-type-330 {
    .pre-seat-map {
      .seat-row {
        .seat-title span {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
  .pre-seat-map {
    white-space: normal;
    text-align: center;
    .seat-row {
      float: none;
      width: 100%;
      height: auto;
      .seat-title {
        // float: left;
        text-align: center;
        display: inline-block;
        div {
          width: 30px;
          height: 30px;
          margin: 3px;
          font-size: 18px;
        }
      }
      .seat-col {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .seat-row {
      zoom: 1;
    }
    .seat-row:before,
    .seat-row:after {
      content: "";
      display: table;
    }
    .seat-row:after {
      clear: both;
    }
  }
}
</style>
